import { API, Headers, IResponse } from '@bemap/utils'

export async function login(
  _email: string,
  _password: string
): Promise<IResponse> {
  const url = '/auth/login-user'
  const body = {
    username: _email,
    password: _password,
  }

  try {
    const access = (await API.post(url, body, await Headers.key()))

    return {
      statusCode: 200,
      message: access?.data?.token,
      error: undefined,
    }
  } catch (error) {
    if (error instanceof Error) {
      return {
        statusCode: 404,
        message: error.message,
        error: error.message,
      }
    }
    return {
      statusCode: 400,
      message: 'Invalid credentials',
      error: 'Invalid credentials',
    }
  }
}